import { type HttpClient } from '../useHttpClient';

type RoleUser = {
  userId: number;
  roleId: number;
};

type RequestSchema = {
  data: RoleUser[];
};

export const removeRoleUsers =
  (httpClient: HttpClient) => async (request: RequestSchema) => {
    await httpClient.api('/admin/roleUsers', {
      method: 'DELETE',
      body: JSON.stringify(request),
    });
  };

export const addRoleUsers =
  (httpClient: HttpClient) => async (request: RequestSchema) => {
    await httpClient.api('/admin/roleUsers', {
      method: 'POST',
      body: JSON.stringify(request),
    });
  };
